omadapp.controllers.dynamic_pageController = function($page) {
    var t = this;
    t.$page = $page
    t.persistence = {}
    var app = omadapp.App
    var factory = omadapp.singletons.factory
    var genTrans = omadapp.singletons.gestorTransiciones
    var domBuilder = omadapp.singletons.domBuilder
    var $app = app.getContext()
    var $b = $("body")
    var totalEscenas = 0
    var escenasCargadas = 0
    t.onCurrent = onCurrent
    t.pausar = pausar
    t.reanudar = reanudar
    t.onExit = onExit
    t.setData = setData
    t.exitPage = exitPage
    t.reset = reset
    t.navegar = navegar
    t.getSceneController = getSceneController
    t.getCurrentSceneController = getCurrentSceneController
    t.createIteracionFeedback = createIteracionFeedback
    t.setIntentoFeedback = setIntentoFeedback
    t.iniciarCronometro = iniciarCronometro
    t.getScenes = getScenes

    var fecha
    var interfaz = omadapp.singletons.interfaz
    var scenes = {};
    var html = $page.html()
    function reset () {
        for (var n in scenes) {
            if (scenes[n].kill && (typeof scenes[n].kill === "function")) {
                scenes[n].kill()
            }
        }
        t.persistence = {}
        t.feedback = {}
        scenes = {}
    }

    function getScenes () {
        return scenes
    }

    function setData (json) {
        trace ("gameEmiController::RESET setData "+json.id)
        reset()
        $page.html("")
        t.datosJuego = json
        trace ("t.datosJuego.reps: "+t.datosJuego.reps)

        inicializarFeedback()
        totalEscenas =0 
        escenasCargadas = 0
        for (var n in json.scenes) {
            totalEscenas++
        }
        for (var n in json.scenes) {
            var sc = json.scenes[n]
            var $sc = domBuilder.crearContenedorEscena (n,$page)
            
            if ($sc.length>0) {
                factory.createScene(sc,$sc,t,escenaCargada)
            } else {
                trace ("escena "+n+" no encontrada")
            }
        }

        $page.find(".scene").each(function(i,o) {
            var $o = $(o)
            if (!scenes[$o.attr("data-sceneId")]) {
                scenes[$o.attr("data-sceneId")] = {$page:$o}
            }
        })

        function escenaCargada (esc) {
            trace ("gameEmiController::escenaCargada")
            //trace (esc)
            escenasCargadas++
            scenes[esc.id] = esc
            if (typeof esc.barajar === 'function'  ) {

                esc.barajar()
            }
            esc.game = t
            
            if (escenasCargadas==totalEscenas) {
                clonarMetodos()
                cargarImagenes()
            }
        }
    }
    function clonarMetodos() {
        var d = t.datosJuego.clonarMetodos||{}
        for (var n in d) {
            var fromScene = d[n].from
            var toScene = d[n].to
            //trace (fromScene)
           // trace (toScene)
            scenes[toScene][n] = scenes[fromScene][n]
        }
    }
    function inicializarFeedback () {
        var d = t.datosJuego
        t.feedback.juego = d.id

        t.feedback.mecanicas = []
        t.feedback.intentos = 0
        t.feedback.aciertos = 0
        t.feedback.fechaIni = new Date()
        t.feedback.tiempoTotal = new Date()
        t.feedback.iteraciones = {}
        
        for (var n in d.scenes) {
            if (d.scenes[n].type == "iteracion") {
                t.feedback.mecanicas.push(d.scenes[n].controller)
            }
        }

    }
    function createIteracionFeedback(controller,estimulo,datosIteracion) {

        var cite = controller.contIteracion
        var cint = controller.intento
        var id = controller.datos.controller+"_"+cite
      
        var iteracion = {
            id: datosIteracion.id,
            time:0,
            try:[]
        }
        t.feedback.iteraciones[id]=t.feedback.iteraciones[id]||iteracion
        t.iteracionFeedback = t.feedback.iteraciones[id]
    }
    function iniciarCronometro () {
        fecha = new Date()
    }
    function setIntentoFeedback (controller,obj,correcto) {

        var cite = controller.contIteracion
        var cint = controller.intento
        var id = controller.datos.controller+"_"+cite
        t.feedback.intentos+=t.feedback.iteraciones[id].try[cint] ? 0 : 1
        t.feedback.aciertos+= correcto ? 1 : 0
        var ahora = new Date()
        var tiempo = ahora - fecha
        t.feedback.iteraciones[id].time += tiempo
        //trace ("tiempo de respuesta: ")
        //trace (tiempo)
        //trace (fecha)
        //trace (ahora)
        var res = {
            time:tiempo,
            pass:correcto,
            game: obj,
            answer: JSON.parse (JSON.stringify(obj.answer))
        }
        obj.answer = null



        t.feedback.iteraciones[id].try[cint] = res
    }


    function cargarImagenes () {
        var arr = []
        $page.find("[src]").each(function(i,o) {
            arr.push (o)
        })
        trace ("gameEmiController::cargarImagenes()")
       // trace (arr)
        omadapp.singletons.preloader.cargarConjunto(arr,function() {
            if (omadapp.modoDebug&&omadapp.debugParams&&omadapp.debugParams.scene) {
                $("body").trigger("dynamicPageLoaded")
                //navegar(omadapp.scene)
                //navegar("intro")
            } else {
                navegar("intro",null,function() {
                     $("body").trigger("dynamicPageLoaded")
                },true)
            }
        }, function (por){
            trace ("porcentaje: "+(por*100)+"%")
        })
    }
    function pausar () {
        trace ("gameEmiController::pausar")
        //trace (t.escenaActual)
        if (t.escenaActual&&t.escenaActual.pausar)t.escenaActual.pausar()
    }
    function reanudar () {
        t.escenaActual&&t.escenaActual.reanudar&&t.escenaActual.reanudar()
    }
    function forzarSalida (e,data) {
        trace ("gameEmiController::forzarSalida")
        trace (e)
        trace (data)
        if (data=="gameEmi") return;

        
        t.escenaActual.onExit()
    }
    function navegar (id,transicion,callback,forzar) {
        trace (" gameEmiController::navegar "+id)
        if (!$page.hasClass("current")&&!forzar)return
       // omadapp.singletons.interfaz.habilitarTodos(false)
        trace (id)
        trace (transicion)
        trace (callback)
        transicion = transicion||"corte";

        //trace_l()
        var saliente = getSceneController($page.find(".scene.current").attr("data-sceneId"))
        var entrante = getSceneController(id)
      //  console.trace ("gameEmiController::navegar "+id)

       // trace (entrante)
       // trace (saliente)
       omadapp.singletons.factory.createSceneComponents(entrante,function(){

        t.escenaActual = entrante
        window.escenaActual = entrante

        genTrans.generarTransicion (entrante,saliente,transicion,null,callback)
       })
    }

    function exitPage (transicion) {

        transicion = transicion||"corte"
        
       /* if (omadapp.debugParams) {
            omadapp.debugParams = null
        }*/

        $b.trigger("pageEnded",t)
        //app.navegar("loading",transicion)
    }

    function getCurrentSceneController () {
        return t.escenaActual
    }
    function getSceneController(id) {
        //trace(scenes)
        return scenes[id] 
    }

    function onCurrent() {
       trace ("gameEmi")
       $b.off("Blapp.navegando",forzarSalida).on("Blapp.navegando",forzarSalida)
      // interfaz.mostrar()
      // interfaz.habilitarTodos(false)

       $b.on("interfaz.__click.help",clicAyuda)
      /* $b.on("interfaz.__click.home",function(){
        exitPage("fundidoNegro")
       })*/
    }
    function clicAyuda(e) {
        /*if (escenaActual.datos.tiempoLimite) {
            var c = escenaActual.clases
            for (var n in c) {
                if (c[n].className&&c[n].className=="Temporizador") {
                    c[n].pausar()
                }
            }

        }*/
        navegar("ayuda","fundidoNegro")
    }

    function onExit() {

       // interfaz.ocultar()
        $b.off("interfaz.__click.help",clicAyuda)
        $b.off("interfaz.__click.home",exitPage)
       //interfaz.deshabilitar("home")

    }

}